import ModalVideo from './modal-video'

export default ModalVideo
